<template>
  <div class="w-100 flex-row">
    <div class="promocode-wrap" style="width:640px">
      <div class="wrap-title" style="margin-bottom:20px">プロモコード作成</div>
      <div class="promocode-box">
        <div class="promocode-title">コード<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.code"></el-input>
        <el-button @click="genCode(20)" size="small">変更</el-button>
      </div>
      
      <div class="promocode-box">
        <div class="promocode-title">スタータープラン1ヶ月</div>
        <el-checkbox v-model="starter1" style="margin-right:10px"></el-checkbox>
        <div v-if="!starter1" class="promocode-checkbox-desc">1ヶ月契約を表示する</div>
        <div v-else class="flex-row"><el-input size="small" class="promocode-input" placeholder="1ヶ月プランの料金を入力" v-model="promoCode.starter_1month"></el-input>円</div>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">スタータープラン3ヶ月</div>
        <el-checkbox v-model="starter3" style="margin-right:10px"></el-checkbox>
        <div v-if="!starter3" class="promocode-checkbox-desc">3ヶ月契約を表示する</div>
        <div v-else class="flex-row"><el-input size="small" class="promocode-input" placeholder="3ヶ月プランの料金を入力" v-model="promoCode.starter_3month"></el-input>円</div>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">スタータープラン6ヶ月<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.starter_6month"></el-input>円
      </div>
      <div class="promocode-box">
        <div class="promocode-title">スタータープラン12ヶ月<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.starter_12month"></el-input>円
      </div>
            
      <div class="promocode-box">
        <div class="promocode-title">マネージャープラン1ヶ月</div>
        <el-checkbox v-model="manager1" style="margin-right:10px"></el-checkbox>
        <div v-if="!manager1" class="promocode-checkbox-desc">1ヶ月契約を表示する</div>
        <div v-else class="flex-row"><el-input size="small" class="promocode-input" placeholder="1ヶ月プランの料金を入力" v-model="promoCode.manager_1month"></el-input>円</div>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">マネージャープラン3ヶ月</div>
        <el-checkbox v-model="manager3" style="margin-right:10px"></el-checkbox>
        <div v-if="!manager3" class="promocode-checkbox-desc">3ヶ月契約を表示する</div>
        <div v-else class="flex-row"><el-input size="small" class="promocode-input" placeholder="3ヶ月プランの料金を入力" v-model="promoCode.manager_3month"></el-input>円</div>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">マネージャープラン6ヶ月<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.manager_6month"></el-input>円
      </div>
      <div class="promocode-box">
        <div class="promocode-title">マネージャープラン12ヶ月<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.manager_12month"></el-input>円
      </div>
      
      <div class="promocode-box">
        <div class="promocode-title">パートナープラン1ヶ月</div>
        <el-checkbox v-model="partner1" style="margin-right:10px"></el-checkbox>
        <div v-if="!partner1" class="promocode-checkbox-desc">1ヶ月契約を表示する</div>
        <div v-else class="flex-row"><el-input size="small" class="promocode-input" placeholder="1ヶ月プランの料金を入力" v-model="promoCode.partner_1month"></el-input>円</div>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">パートナープラン3ヶ月</div>
        <el-checkbox v-model="partner3" style="margin-right:10px"></el-checkbox>
        <div v-if="!partner3" class="promocode-checkbox-desc">3ヶ月契約を表示する</div>
        <div v-else class="flex-row"><el-input size="small" class="promocode-input" placeholder="3ヶ月プランの料金を入力" v-model="promoCode.partner_3month"></el-input>円</div>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">パートナープラン6ヶ月<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.partner_6month"></el-input>円
      </div>
      <div class="promocode-box">
        <div class="promocode-title">パートナープラン12ヶ月<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.partner_12month"></el-input>円
      </div>
      
      <div class="promocode-box">
        <div class="promocode-title">プロプラン1ヶ月</div>
        <el-checkbox v-model="pro1" style="margin-right:10px"></el-checkbox>
        <div v-if="!pro1" class="promocode-checkbox-desc">1ヶ月契約を表示する</div>
        <div v-else class="flex-row"><el-input size="small" class="promocode-input" placeholder="1ヶ月プランの料金を入力" v-model="promoCode.pro_1month"></el-input>円</div>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">プロプラン3ヶ月</div>
        <el-checkbox v-model="pro3" style="margin-right:10px"></el-checkbox>
        <div v-if="!pro3" class="promocode-checkbox-desc">3ヶ月契約を表示する</div>
        <div v-else class="flex-row"><el-input size="small" class="promocode-input" placeholder="3ヶ月プランの料金を入力" v-model="promoCode.pro_3month"></el-input>円</div>
      </div>
      <div class="promocode-box">
        <div class="promocode-title">プロプラン6ヶ月<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.pro_6month"></el-input>円
      </div>
      <div class="promocode-box">
        <div class="promocode-title">プロプラン12ヶ月<span style="color:red">*</span></div>
        <el-input size="small" class="promocode-input" v-model="promoCode.pro_12month"></el-input>円
      </div>
      <div class="promocode-box">
        <div class="promocode-title">有効期限<span style="color:red">*</span></div>
        <el-date-picker v-model="promoCode.expiration_at" type="date" style="width:120px; margin-right:10px"></el-date-picker><span class="promocode-checkbox-desc">23:59:59まで</span>
      </div>
      <div class="divider full"></div>
      <div class="w-100 flex-row" style="justify-content:flex-end">
        <el-button type="primary" @click="createPromoCode()">プロモコード作成</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const createPromoCodeAPI = root + "/api/admin/create_promocode";

export default {
  name: "promoCode",
  data() {
    return {
      promoCode: {
        code: "",
        starter_1month: "",
        starter_3month: "",
        starter_6month: 40000,
        starter_12month: 30000,
        manager_1month: "",
        manager_3month: "",
        manager_6month: 125000,
        manager_12month: 100000,
        partner_1month: "",
        partner_3month: "",
        partner_6month: 175000,
        partner_12month: 150000,
        pro_1month: "",
        pro_3month: "",
        pro_6month: 350000,
        pro_12month: 300000,
        expiration_at: this.calculate10DaysLaterDate(),
        created_at: +new Date(),
      },
      starter1: false,
      starter3: false,
      manager1: false,
      manager3: false,
      partner1: false,
      partner3: false,
      pro1: false,
      pro3: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    activate_at() {
      return this.$store.state.activate_at;
    },
  },
  mounted() {
    this.genCode(20);
  },
  methods: {
    genCode(length = 20) {
      let password_base = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!$";
      let password = "";
      for (let i = 0; i < length; i++) {
        password += password_base.charAt(Math.floor(Math.random() * password_base.length));
      }
      this.promoCode.code = password;
    },
    createPromoCode() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("promoCode", JSON.stringify(this.promoCode));
      this.axios
        .post(createPromoCodeAPI, params)
        .then((response) => {
          if (response.data.promocode) {
            this.$alert("生成されたコード: "+response.data.promocode, "プロモコードを作成しました。", {});
            this.promoCode.code = ""; // 重複登録回避の為プロモコードを削除
          } else {
            this.$message.error("プロモーションコードの作成に失敗しました。入力内容が正しいか確認してください");  
          }
        })
        .catch(() => {
          this.$message.error("プロモーションコードの作成に失敗しました。入力内容が正しいか確認してください");
        });
    },
    calculate10DaysLaterDate() {
      const today = new Date();
      today.setDate(today.getDate() + 10);
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // 月は0から始まるため、1を加算
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  },
  watch: {
    starter1() {
      this.promoCode.starter_1month = "";
    },
    starter3() {
      this.promoCode.starter_3month = "";
    },
    manager1() {
      this.promoCode.manager_1month = "";
    },
    manager3() {
      this.promoCode.manager_3month = "";
    },
    partner1() {
      this.promoCode.partner_1month = "";
    },
    partner3() {
      this.promoCode.partner_3month = "";
    },
    pro1() {
      this.promoCode.pro_1month = "";
    },
    pro3() {
      this.promoCode.pro_3month = "";
    },
  },
  filters: {},
};
</script>
